var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tag',{attrs:{"type":_vm.tagType,"effect":_vm.effect,"size":"small"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }